import { NgModule } from '@angular/core';

import { GeoModule } from './geo.module';
import { GeoLayerDataBrowserService } from './services/geoLayerData.browser.service';
import { GeoLayerDataServiceInjector } from './services/geoLayerData.service';

@NgModule({
  imports: [GeoModule],
  providers: [{ provide: GeoLayerDataServiceInjector, useClass: GeoLayerDataBrowserService }],
  exports: [GeoModule],
})
export class GeoBrowserModule {}
